import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { IUserProfile } from '../models';

export interface ProfileState {
    profile: IUserProfile | undefined;
}

export const initialState: ProfileState = {
    profile: undefined,
};

const administrationReducer = createReducer(
    initialState,
    on(actions.getProfile, (state, payload) => {
        return {
            ...state,
            profile: payload.profile,
        };
    }),
    on(actions.clearProfile, (state) => {
        return {
            ...state,
            profile: null,
        };
    }),
   
);
export function profileReducer(state: ProfileState | undefined, action: Action) {
    return administrationReducer(state, action);
}
